import React from 'react'
import BackgroundFx from './BackgroundFx'
import SiteHeader from './SiteHeader'
import SideNav from './SideNav'
import ThemeController from './ThemeController'
import { useCustomCursor } from '../../hooks/useCustomCursor'
import HeroSection from '../sections/HeroSection'
import IdentitySection from '../sections/IdentitySection'
import CosmosSection from '../sections/CosmosSection'
import VerseSection from '../sections/VerseSection'
import CapabilitiesSection from '../sections/CapabilitiesSection'
import ThinkingSection from '../sections/ThinkingSection'
import ServicesSection from '../sections/ServicesSection'
import StackSection from '../sections/StackSection'
import ToolkitSection from '../sections/ToolkitSection'
import MetricsSection from '../sections/MetricsSection'
import StatementSection from '../sections/StatementSection'
import PrinciplesSection from '../sections/PrinciplesSection'
import ConnectSection from '../sections/ConnectSection'
import OutroSection from '../sections/OutroSection'

export default function SiteShell() {
    useCustomCursor()
    return (
        <>
            <div className="cursor-ring" aria-hidden="true" />
            <div className="cursor-dot" aria-hidden="true" />
            <BackgroundFx />
            <SiteHeader />
            <SideNav />
            <ThemeController />
            <main style={{ position: 'relative', zIndex: 1 }}>
                <HeroSection />
                <IdentitySection />
                <CosmosSection />
                <VerseSection />
                <CapabilitiesSection />
                <ThinkingSection />
                <ServicesSection />
                <StackSection />
                <ToolkitSection />
                <MetricsSection />
                <StatementSection />
                <PrinciplesSection />
                <ConnectSection />
                <OutroSection />
            </main>
        </>
    )
}
